import React from 'react'
import styles from './KevinProfilePage.module.css'

import taco from '../../assets/Taco.jpg'

const KevinProfilePage = () => {  
    const [tacos, setTacos] = React.useState(false);
    const [noTacos, setNoTacos] = React.useState(false);

    const handleTacos = () => {
        setTacos(true);
        setNoTacos(false);
    }

    const handleNoTacos = () => {
        setNoTacos(true);
        setTacos(false);
    }

    return(
        <div className={styles.background}>
            <img src={taco} width='300' height='300'></img>
            <h1>Kevin Zhong</h1>
            <div>
                <p className={styles.aboutMe}>Hello! My name is Kevin Zhong, a third year Computer Science major at the University at Buffalo. <br></br> Let's get to know each other!</p>
            </div>
            <br></br>
            <div>Do you like tacos?</div>
            <button onClick={handleTacos}>Yes</button>
            <button onClick={handleNoTacos}>No</button>

            {tacos && <div>Great! I love tacos too!</div>}
            {noTacos && <div>That's okay, tacos aren't for everyone.</div>}
        </div>
    )
}

export default KevinProfilePage;